import {
  admin_holidays_path,
  admin_projects_path,
  admin_setting_path,
  admin_tags_path,
  admin_users_path,
} from '@/rails/routes';
import { Heading } from '@astryxdesign/core/Heading';
import { Tab, TabList } from '@astryxdesign/core/TabList';
import { Text } from '@astryxdesign/core/Text';
import { VStack } from '@astryxdesign/core/VStack';
import { usePage } from '@inertiajs/react';

const SECTIONS = [
  { label: 'Usuarios', path: admin_users_path() },
  { label: 'Proyectos', path: admin_projects_path() },
  { label: 'Etiquetas', path: admin_tags_path() },
  { label: 'Días no laborables', path: admin_holidays_path() },
  { label: 'Reglas de edición', path: admin_setting_path() },
];

export default function AdminNav() {
  const { url } = usePage();
  const currentPath = url.split('?')[0];

  return (
    <VStack gap={1}>
      <Heading level={1}>Administración</Heading>
      <Text type="body" color="secondary">
        Configuración del equipo y del catálogo compartido del parte diario.
      </Text>
      <TabList
        value={currentPath}
        onChange={() => undefined}
        hasDivider
        className="iorio-admin-tabs mt-4"
        aria-label="Secciones de administración"
      >
        {SECTIONS.map((section) => (
          <Tab key={section.path} value={section.path} label={section.label} href={section.path} />
        ))}
      </TabList>
    </VStack>
  );
}
